import React, { Component } from 'react'
import EditAlertContentField from './EditAlertContentField'
import SelectSteps from './SelectSteps'
import SearchFilter from '../../../../Templates/SearchFilter'
import CategorySelection from './CategorySelection'
import {isEmpty} from "lodash"
import FormColumn from '../../../../Templates/FormColumn'
import Checkbox from '@material-ui/core/Checkbox';
export default class AddInfoFormRevised extends Component {
    constructor(props) {
        super()
        this.state = {
            stepNames: props.steps.map(step => step.name),
            filteringCategory: undefined,
            filteringStepId: undefined,
            editingItem: null,
            pendingAlerts: {}
        }
    }

    componentWillUnmount = () => {
        this.runInfoPageCleanUp()
    }

    addCategoryToInfoItem = (categoryName, infoItem) => {
        let infoPage = this.props.infoPage
        if (infoPage[infoItem].category !== categoryName) {
            infoPage[infoItem].category = categoryName
            this.props.updateInfoPage(infoPage)
        }
        return
    }

    addAlertToPage = () => {
        //items are created with a hidden 'nullStepItem' name (since object keys must have a name). 
        //this function dynamically creates unique 'nullStepItem' names by adding a sequence.
        //when the add info page form closes all 'item names that still include 'nullStepItem' are discarded through runInfoPageCleanUp function.
        let infoPage = this.props.infoPage
        let i = 1
        let found = false
        let itemName
        while (!found) {
            if (!infoPage[`nullStepItem${i}`]) {
                itemName = `nullStepItem${i}`
                found = true
                break
            }
            i++
        }

        infoPage[itemName] = { category: "", steps: [] }
        this.props.updateInfoPage(infoPage)
    }

    addItemToStep = (id, infoItem) => {
        let infoPage = this.props.infoPage
        let newSteps
        if (infoPage[infoItem].steps.includes(id)) {
            newSteps = infoPage[infoItem].steps.filter(testid => testid !== id)
            infoPage[infoItem].steps = newSteps
        } else {
            infoPage[infoItem].steps.push(id)
        }
        this.props.updateInfoPage(infoPage)
    }

    deleteItem = (infoItem) => {
        let infoPage = this.props.infoPage
        delete infoPage[infoItem]
        this.props.updateInfoPage(infoPage)
    }

    editItemName = (infoItem, newName) => {
        if (!newName.trim()) return;
        
        let infoPage = {...this.props.infoPage}
        
        // If it's a new alert (nullStepItem)
        if (infoItem.includes("nullStepItem")) {
            infoPage[newName] = infoPage[infoItem] || { category: "", steps: [] }
            delete infoPage[infoItem]
        } else {
            infoPage[newName] = {...infoPage[infoItem]}
            delete infoPage[infoItem]
        }
        
        this.props.updateInfoPage(infoPage)
    }

    runInfoPageCleanUp = () => {
        let infoPage = this.props.infoPage
        let infoItems = Object.keys(infoPage)

        infoItems.forEach(item => {
            if (item.includes("nullStepItem")) {
                delete infoPage[item]
            }
        })
        this.props.updateInfoPage(infoPage)
    }

    setFilter = (state, filter) => {
        if (state === "Category" && (!this.state.filteringCategory || this.state.filteringCategory !== filter)) {
            this.setState({filteringCategory: filter, filteringStepId: undefined, filteringGlobal: undefined})
        } else if (state === "Step" && (!this.state.filteringStepId || this.state.filteringStepId !== filter)) {
            this.setState({filteringStepId: filter, filteringCategory: undefined, filteringGlobal: undefined})
        } else if (state === "Global" && (!this.state.filteringGlobal || this.state.filteringGlobal !== filter)) {
            this.setState({ filteringGlobal: filter, filteringCategory: undefined, filteringStepId: undefined })
        } else {
            this.setState({filteringStepId: undefined, filteringCategory: undefined, filteringGlobal: undefined})
        }
    }



    filterItemsList = (searchText) => {
        let infoItems = Object.keys(this.props.infoPage)
        if (searchText === "") {
            this.setState(prevState => ({
                filteredItems: [],
            }))
        }
        this.setState(prevState => ({
            filteredItems: infoItems.filter(infoItem => infoItem.toLowerCase().includes(searchText)),
            filteringItems: true
        }))
    }

    toggleGlobalItem = (itemIndex) => {
        let index = 0;
        let infoPage = this.props.infoPage

        for (let infoItem in infoPage) {
            if (index === itemIndex) {
                infoPage[infoItem].global = !infoPage[infoItem].global
            }
            index++
        }
        this.props.updateInfoPage(infoPage)
    }

    render = () => {
        let infoPage = this.props.infoPage
        let infoItems = isEmpty(infoPage) ? [] : Object.keys(infoPage)
        //sets up default categories to insert into add info form
        let categories = {"Cautions": {title: "Cautions"}, "Warnings": {title: "Warnings"}, "Notes": {title: "Notes"}}
        
        infoItems.forEach(infoItem => {
            let category = infoPage[infoItem].category
            if (categories[category] || !category) {return}
                categories[category] = { title: category}});

            if (this.state.filteringItems) {
                infoItems = this.state.filteredItems
            }

            if (this.state.filteringCategory) {
                infoItems = infoItems.filter(infoItem => {
                    return infoPage[infoItem].category === this.state.filteringCategory
                });
            }

            if (this.state.filteringStepId) {
                infoItems = infoItems.filter((infoItem) => {
                    return infoPage[infoItem].steps.includes(this.state.filteringStepId)
                });
            }

            if (this.state.filteringGlobal) {
                infoItems = infoItems.filter((infoItem) => {
                    if (this.state.filteringGlobal === "Global") {
                        return infoPage[infoItem].global === true
                    } else {
                        return !infoPage[infoItem].global
                    }
                });
            }

            const globals = []
            const names = []
            const categorySelection = []
            const stepSelections = []
            const checkBoxes = []
            

            infoItems.forEach((infoItem, index) => {           
                const selectedStepsIds = infoPage[infoItem].steps || []
                const isGlobal = infoPage[infoItem].global
                globals.push(isGlobal)
                names.push(
                    this.state.editingItem === infoItem || infoItem.includes("nullStepItem") ? 
                    <li>
                        <EditAlertContentField
                            infoItem={infoItem}
                            editItemName={this.editItemName}
                            cancel={() => this.setState({ editingItem: "" })} />
                    </li>
                    : 
                    <li style={{alignItems: "center", justifyContent: 'flex-start'}} onClick={() => this.setState({editingItem: infoItem})}>
                            <p className="ellipsis" style={{height:'34px', marginTop: '8px'}} >{infoItem}</p>
                    </li>
                )
                categorySelection.push(<CategorySelection
                    categories={Object.values(categories)}
                    addCategoryToInfoItem={this.addCategoryToInfoItem}
                    category={infoPage[infoItem].category}
                    infoItem={infoItem}
                />)
                stepSelections.push( 
                    <SelectSteps
                        isGlobal={isGlobal}
                        addItemToStep={this.addItemToStep}
                        infoItem={infoItem}
                        selectedStepsIds={selectedStepsIds || []}
                        steps={this.props.steps}
                        stepNames={this.state.stepNames} 
                    />
                )
                checkBoxes.push(
                    <div className="max-size flex-centered">
                        <Checkbox
                            onClick={() => this.setState({selectedInfoItem: infoItem})}
                            checked={infoItem === this.state.selectedInfoItem ? true : false}
                            color="primary"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />  
                    </div>
                )
            })
            
        return <div id="add-info-form" className="flex max-width">
            <div id="add-info-form-content-container" className="max-width" style={{height: "95%"}}>
                    <div style={{width: "55%", padding: ".5em 1.75em"}}>
                        <SearchFilter filterList={this.filterItemsList} placeholder="Search Info Items" style={{ border: "2px solid grey", margin: ".25em 0 .25em -1em"}}/>
                    </div>

                    <ul className="flex overflow-y" id="info-items-list">
                        <FormColumn title={""} content={checkBoxes} nullSort columnWidth={"48px"} classNames="marginNone"/>
                        <FormColumn title={"Alert Content"} content={names} columnWidth={"calc(100% - 398px)"} fragments={true} classNames="marginLeftQuarter"/>
                        <FormColumn title={"Category"} content={categorySelection} columnWidth={"150px"} />
                        <FormColumn title={"Applied Steps"} content={stepSelections} nullSort columnWidth={"200px"}/>
                    </ul>
                </div>


            {/* Create and Delete Buttons */}
            <div className="flex-apart" style={{width: '30%', marginLeft: '1em'}}>
                <button 
                    onClick={this.addAlertToPage}
                    style={{
                        width: '200px',
                        height: '45px',
                        backgroundColor: '#081F5F',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontWeight: '500',
                        marginRight: '15px'
                    }}>
                    Create Alert
                </button>
                <button 
                    onClick={this.state.selectedInfoItem ? () => this.deleteItem(this.state.selectedInfoItem) : null}
                    disabled={!this.state.selectedInfoItem}
                    style={{
                        width: '200px',
                        height: '45px',
                        backgroundColor: '#F3F3F3',
                        color: '#081F5F',
                        border: '1px solid #081F5F',
                        borderRadius: '5px',
                        cursor: this.state.selectedInfoItem ? 'pointer' : 'not-allowed',
                        fontSize: '1rem',
                        fontWeight: '500',
                        opacity: this.state.selectedInfoItem ? 1 : 0.7,
                        marginLeft: '15px'
                    }}>
                    Delete Alert
                </button>
            </div>
        </div>
    }
}